import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useHistory } from 'react-router-dom';

import { checkoutState, currentRmaState, accountState } from 'state/atoms';
import { storageCheckoutSelector } from 'state/selectors';
import {
  CHECKOUT_SHIPPING_STEP,
  CHECKOUT_BILLING_STEP,
  CHECKOUT_STEP_SEQUENCE,
} from 'utils/constants';
import { getTotalCasePrice } from 'utils/helpers';
import { getValidationSchema as getShippingValidationSchema } from 'pages/CheckoutShipping/validationSchema';
import { getValidationSchema as getBillingValidationSchema } from 'pages/CheckoutBilling/validationSchema';

export const useCheckoutStepsValidation = (currentStep) => {
  const history = useHistory();
  const { items } = useRecoilValue(currentRmaState);
  const checkout = useRecoilValue(checkoutState);
  const accountData = useRecoilValue(accountState);
  const setCheckout = useSetRecoilState(storageCheckoutSelector);

  const caseHasCost =
    getTotalCasePrice(
      items,
      checkout.shipping.method,
      accountData.getDefaultBillToAddress,
      accountData.currencyConversionRate
    ) > 0;

  const validateSteps = async () => {
    const currentStepIndex = CHECKOUT_STEP_SEQUENCE.indexOf(currentStep);
    const shippingStepIndex = CHECKOUT_STEP_SEQUENCE.indexOf(CHECKOUT_SHIPPING_STEP);
    const billingStepIndex = CHECKOUT_STEP_SEQUENCE.indexOf(CHECKOUT_BILLING_STEP);

    // Validate each step schema previous to the current step
    return {
      [CHECKOUT_SHIPPING_STEP]:
        currentStepIndex > shippingStepIndex
          ? await getShippingValidationSchema().isValid({
              ...checkout.shipping,
              ...checkout.shipping.address,
            })
          : true,
      [CHECKOUT_BILLING_STEP]:
        currentStepIndex > billingStepIndex
          ? await getBillingValidationSchema().isValid(checkout.billing, {
              context: { caseHasCost },
            })
          : true,
    };
  };

  return async () => {
    const validationResults = await validateSteps();

    if (!items.length) {
      history.replace('/cases/new/details');
    } else if (!validationResults[CHECKOUT_SHIPPING_STEP]) {
      setCheckout({
        ...checkout,
        shipping: { ...checkout.shipping, touched: true },
      });
      history.replace('/cases/new/checkout/shipping');
    } else if (!validationResults[CHECKOUT_BILLING_STEP]) {
      setCheckout({
        ...checkout,
        billing: { ...checkout.billing, touched: true },
      });
      history.replace('/cases/new/checkout/billing');
    } else return true;
  };
};
